export let SnapshotType;

(function (SnapshotType) {
  SnapshotType["DEPOSIT"] = "deposit";
  SnapshotType["TRANSFER"] = "transfer";
  SnapshotType["WITHDRAWAL"] = "withdrawal";
  SnapshotType["WITHDRAWAL_FEE_CHARGED"] = "fee";
  SnapshotType["WITHDRAWAL_FAILED"] = "rebate";
  SnapshotType["RAW"] = "raw";
})(SnapshotType || (SnapshotType = {}));

export let SnapshotSource;

(function (SnapshotSource) {
  SnapshotSource["DEPOSIT_CONFIRMED"] = "DEPOSIT_CONFIRMED";
  SnapshotSource["TRANSFER_INITIALIZED"] = "TRANSFER_INITIALIZED";
  SnapshotSource["WITHDRAWAL_INITIALIZED"] = "WITHDRAWAL_INITIALIZED";
  SnapshotSource["WITHDRAWAL_FEE_CHARGED"] = "WITHDRAWAL_FEE_CHARGED";
  SnapshotSource["WITHDRAWAL_FAILED"] = "WITHDRAWAL_FAILED";
})(SnapshotSource || (SnapshotSource = {}));